<template>
  <div class="layout-padding" :class="{'modalpage':page==='superpartner'}">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="멤버 조회"
      desc="등록한 멤버들의 현황을 조회할 수 있습니다.">
      <lp-adm-drop-input slot="group_category"
                         :data.sync="cats"
                         :selectVal="selectedGroup"
                         @onSelect="selectCategory"
                         placeholder="팀 선택"
                         width="160px"
                         listAlign="center"
                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
    </admin-filter>


    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="manager" slot-scope="props">
        <div v-if="!props.item.leader">
          <button class="button is-primary" @click.stop.prevent="openManagerModal(props.item)" v-if="!props.item.manager">매니저 추가</button>
          <button class="button is-primary" @click.stop.prevent="deleteManageModal(props.item)" v-else>매니저 해지</button>
        </div>
        <div v-else>-</div>
      </div>

      <div slot="leader" slot-scope="props">
        <div v-if="!props.item.leader">
          <button class="button is-primary"
                  @click.stop.prevent="openLeaderModal(props.item)">리더위임</button>
        </div>
        <div v-else>-</div>
      </div>


      <div slot="modify_delete" slot-scope="props">
        <div v-if="!props.item.leader">
          <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">탈퇴</button>
        </div>
        <div v-else>-</div>
      </div>
    </admin-table>

    <modal name="addManagerModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedItem">
        <div>{{ `${selectedItem.name} 님을 ${selectedItem.group_name} 팀의 매니저로 ` }} 추가하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('addManagerModal')">취소</button>
          <button class="button is-primary" @click="addManager">확인</button>
        </div>
      </div>
    </modal>

    <modal name="deleteManagerModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedItem">
        <div>{{ `${selectedItem.name} 님을 ${selectedItem.group_name} 팀의 매니저를 ` }} 해지시키겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('deleteManagerModal')">취소</button>
          <button class="button is-primary" @click="deleteManager">확인</button>
        </div>
      </div>
    </modal>

    <modal name="changeLeaderModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedItem">
        <div>{{ `${selectedItem.name} 님을 ${selectedItem.group_name} 팀의 리더로 ` }} 임명하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('changeLeaderModal')">취소</button>
          <button class="button is-primary" @click="changeLeader">확인</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheck from "../../../module/common/LpCheck";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import GroupMixin from "@/mixins/GroupMixin"

  export default {
    name: 'GroupMemberList',
    layout:'Main',
    mixins: [
      ListMixin,
      GroupMixin
    ],
    props: ['page', 'selectedItems'],
    components: {
      LpAdmDropInput,
      LpCheckBool,
      LpCheck

    },
    data () {
      return {
        selectedItem: undefined,
        cats: [],
        selectedGroup:''
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('group_member', 'group/user');
        this.filtered.group = this.param_group_id;
        if(this.filtered.group !== '') {
          removeIndex(this.filterData,0);
        } else {
          this.getGroupList('cats', true);
        }
      },
      getDataFromServer() {
        this.getData();
      },
      deleteManageModal(item) {
        this.$modal.show('deleteManagerModal');
        this.selectedItem = item;
      },
      openManagerModal(item) {
        this.$modal.show('addManagerModal');
        this.selectedItem = item;
      },
      openLeaderModal(item) {
        this.$modal.show('changeLeaderModal');
        this.selectedItem = item;
      },
      deleteManager() {
        this.$axios.post(this.getUrl(`group/${this.selectedItem.group}/user/auth/change`), {
          auth: 3,
          user_id: this.selectedItem.id
        }).then(res=>{
          if(res.status===200) {
            this.toast('매니저 해지가 완료되었습니다.');
            this.getData();
            this.$modal.hide('deleteManagerModal');
          }
        });
      },
      addManager() {
        this.$axios.post(this.getUrl(`group/${this.selectedItem.group}/user/auth/change`), {
          auth: 2,
          user_id: this.selectedItem.id
        }).then(res=>{
          if(res.status===200) {
            this.toast('매니저 추가가 완료되었습니다.');
            this.getData();
            this.$modal.hide('addManagerModal');
          }
        });
      },
      changeLeader() {
        this.$axios.post(this.getUrl(`group/${this.selectedItem.group}/leader/delegate`), {
          user_id: this.selectedItem.id
        }).then(res=>{
          if(res.status===200) {
            this.toast('리더 위임이 완료되었습니다.');
            this.getData();
            this.$modal.hide('changeLeaderModal');
          }
        });
      },
      selectCategory(e) {
        this.filtered.page_num = 1;
        if(e.value === '' || e.value === 0) {
          delete this.filtered.group;
          this.selectedGroup = '';
        }

        else {
          this.filtered.group = e.value;
          this.selectedGroup = e.label;
        }

        this.getData();
      },
      clickModifyDelete(item, type) {
        if(type === 'delete') {
          let value = {
            url: `group/${item.group}/user/force/deleter?user_id=${item.id}`,
            title: '멤버를 탈퇴시키겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .simple-desc
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

  .modalpage
    margin-top 50px
    padding: 1.25rem
</style>
